/**
 * Route paths constants
 */
export const ROUTES = {
  HOME: '/',
  HOME_EN: '/en',
  LOGIN: '/login',
  CALLBACK: '/callback',
  PRICING: '/pricing',
  PRICING_EN: '/en/pricing',
  ORDERS: '/orders',
  NOT_FOUND: '*',
} as const;

/**
 * Route names for better code readability
 */
export const ROUTE_NAMES = {
  HOME: 'home',
  HOME_EN: 'homeEn',
  LOGIN: 'login',
  CALLBACK: 'callback',
  PRICING: 'pricing',
  ORDERS: 'orders',
  NOT_FOUND: 'notFound',
} as const;

export type RoutePath = typeof ROUTES[keyof typeof ROUTES];

